import type { FC } from 'react';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useTranslation } from '~/hooks';
import { getDurationStringUntilNow } from '~/utils/format';

type PublishedDateProps = {
  publishedAt: string;
  'data-testid'?: string;
};

// The server renders in UTC and the HTML is cached, so the browser computes another text. React 18 replaces a
// suppressed text mismatch with the browser's text on hydration; React 19 keeps the server's.
export const PublishedDate: FC<PublishedDateProps> = ({ publishedAt, 'data-testid': testId }) => {
  const t = useTranslation();
  const { language } = useBusinessUnitContext();

  return (
    <span data-testid={testId} suppressHydrationWarning>
      {`${t('missions.published')} ${getDurationStringUntilNow(publishedAt, t('date.today'), language)}`}
    </span>
  );
};
